import { getUserInformation } from '../Login/loginService';

export function getAccountName() {
    const user = getUserInformation();
    let accountName = 'default';
    if (user) {
        accountName = user.accountName;
    }
    else {
        let client = localStorage.getItem('x-olympia-client');
        accountName = process.env.REACT_APP_CLIENT_NAME;
        if (client && client != '') {
            accountName = client;
        }
    }
    return accountName;
}



// WEBPACK FOOTER //
// ./src/components/Utils/UserFunctions.js